import { Button } from '@ui';
import HOCAddPatient from '@components/hoc-add-patient';
import { getDateFormat } from '@helpers/utils-helpers';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import FeedCardHeader from '../../feed-card-header';
import FeedIcon from '../../feed-icon';
import { FeedPatientsSC } from '../../feed.styled';
import { PlusOutlined } from '@icon';

const _AddButton = (props: { onAddPatient: () => void }) => {
  return (
    <Button
      variant="primary"
      block={false}
      onClick={props.onAddPatient}
      Icon={PlusOutlined}
      size="medium"
    >
      <FormattedMessage id="patients.add_patient" />
    </Button>
  );
};

const AddButton = HOCAddPatient(_AddButton);

const FeedNoPatients: React.FC = () => {
  const history = useHistory();

  return (
    <FeedPatientsSC className="feed-card">
      {/* <FeedIcon>
        <img
          src={require('@assets/svg/icon-new-patients.svg').default}
          width="24"
          height="25"
          alt=""
        />
      </FeedIcon> */}
      <FeedCardHeader
        title={<FormattedMessage id="patients.incoming_requests" />}
        onClick={() => {
          history.push('');
        }}
      />
      <div className="body-empty">
        <div className="feed-time">{moment().format(getDateFormat())}</div>
        <div className="body-empty-content">
          <p>
            <FormattedMessage id="patients.no_incoming_requests" />
          </p>
          <AddButton />
        </div>
      </div>
    </FeedPatientsSC>
  );
};

export default FeedNoPatients;
